<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Appointment } from '../../../modules/schedulerApi/appointments/appointment'
    import { AppointmentStatus, AppointmentStatusFriendly } from '../../../modules/schedulerApi/appointments/appointments.enum'
    import type { Schedule } from '../../../modules/schedulerApi/schedules/schedule'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { faUser } from '@fortawesome/free-solid-svg-icons'

    const RELEVANT_STATUS = [AppointmentStatus.agendamento_faltou, AppointmentStatus.agendamento_cancelado_usuario, AppointmentStatus.agendamento_cancelado_empresa]

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Appointment[] = await window.api.schedulers.appointments.getAll({ from, to })
        data = data.filter((a) => RELEVANT_STATUS.includes(a.status))
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        const schedules: Schedule[] = await window.api.schedulers.schedules.getAll({ all: true, slots: false }, 600)
        for (const appointment of data) {
            appointment.schedule = schedules.find((el) => el.scheduleId === appointment.scheduleId)
            appointment.items = await window.api.utils.utils.assignServicesFromObject(appointment.items)
        }
        console.log('relat.data', data)
        loadGrid(data)
        show = false
    }

    function loadGrid(data: Appointment[]) {
        grid = new GridClass()
        grid.title = 'Faltas e cancelamentos'
        grid.cols.push(new GridCol({ content: 'Cliente' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'Agenda' }))
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Serviços' }))
        grid.cols.push(new GridCol({ content: 'Status' }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))

        for (const item of data) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.person?.name })
            line.slots.push({ content: item.person?.phone })
            line.slots.push({ content: item.schedule?.label })
            line.slots.push({ content: item.start })
            line.slots.push({ content: (item.items || []).map((el) => el.service?.name).join(', ') })
            line.slots.push({ content: AppointmentStatusFriendly[item.status] })
            line.slots.push({ content: [new GridButton({ callback: () => window.person('show', item.personId), icon: faUser })] })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
